// import { authenticationService } from '../_services';

export function authHeader() {
   
    return {};
   
}